<template>
  <div class="productList" ref="container">
    <div v-if="srachState">
      <nav-bar
        fixed
        z-index="99"
        title="搜索"
        left-text="返回"
        left-arrow
        @click-left="$router.go(-1)"
      />
      <div style="height: 46px"></div>
    </div>
    <div :offset-top="srachState ? 0 : '0.84rem'" :class="{ fixd: srachState }">
      <!-- <div v-if="!isLogin" class="advert-box" @click="$router.push('/evaluation')">
        <img src="@/assets/images/advert1.png" alt="" />
      </div> -->

      <form
        class="category-toach"
        style="background-color: #ffffff; position: relative"
        @submit="
          (e) => {
            e.preventDefault();
            submitForm();
          }
        "
      >
        <div class="category-toach search acea-row row-between-wrapper">
          <div class="category-toach input acea-row row-middle">
            <div
              class="category-toach acea-row row-middle"
              @click.stop="inputClick"
            >
              <span class="category-toach iconfont icon-sousuo"></span>
              <input
                class="category-toach"
                placeholder="搜索教练名称/擅长领域"
                v-model="keyword"
                @submit="submitForm"
                @focus="inputFocus"
                @blur="inputBlur"
              />
            </div>
            <img
              class="category-toach"
              v-if="keyword"
              @click="inputClear"
              style="width: 0.4rem; margin-left: 0.26rem"
              src="../../assets/img/close.png"
            />
          </div>
          <div class="category-toach search-btn" @click="submitForm">
            全部教练
          </div>
        </div>
        <div
          class="category-toach search-category"
          v-show="categoryShow && !keyword"
        >
          <div
            class="category-toach search-category-item"
            v-for="(item, index) in category"
            :key="index"
            @click="categorySelect(item)"
          >
            {{ item.cateName }}
          </div>
        </div>
      </form>
      <div class="consultant acea-row row-between-wrapper" v-if="!srachState">
        <div class="consultant-item" @click="$router.push('/news_detail/1585')">
          <img class="consultant-img" :src="articleImg[2]" />
          <span>什么是家庭教练</span>
        </div>
        <div class="consultant-item" @click="$router.push('/news_detail/1584')">
          <img class="consultant-img" :src="articleImg[1]" />
          <span>家庭教练适合我吗</span>
        </div>
      </div>
      <!-- {{ console.log($route) }} -->
      <!-- <div
        class="advert-box"
        v-if="$route.path == '/'"
        @click="$router.push('/evaluation')"
      >
        <img src="@/assets/images/advert1.png" alt="" />
      </div> -->

      <div class="nav">
        <dropdown-menu active-color="#0CE6DF">
          <dropdown-item
            v-model="sort"
            title="综合排序"
            :options="sortOption"
            @change="submitForm"
          />
          <dropdown-item
            v-model="type"
            title="约见方式"
            :options="typeOption"
            @change="submitForm"
          />
          <dropdown-item
            v-model="price"
            title="单价/次"
            :options="priceOption"
            @change="submitForm"
          />
          <dropdown-item
            v-model="address"
            :title="addressText"
            ref="addressItem"
            title-class="address-filter"
            @open="addressOpen"
            @close="addressClose"
          >
            <template #title
              >{{ addressText
              }}<img
                style="width: 0.36rem; vertical-align: middle"
                src="@assets/img/icon_address.png"
            /></template>
            <cascader
              active-color="#0ce6df"
              v-model="address"
              title="请选择所在地区"
              :options="$store.state.app.addressOption"
              @finish="addressFinish"
              :show-header="false"
              :field-names="{ text: 'n', value: 'v', children: 'c' }"
            />
          </dropdown-item>
        </dropdown-menu>
      </div>
    </div>
    <div
      class="good-list-other"
      :style="srachState ? 'margin-top:1.9rem;' : 'margin-top:0;'"
      :class="Switch === true ? '' : 'on'"
      ref="container"
    >
      <Promotion-good
        :benefit="productList"
        :isFirst="isFirst"
      ></Promotion-good>
    </div>
    <Loading :loaded="loadend" :loading="loading" v-if="srachState"></Loading>
    <div
      class="noCommodity"
      v-cloak
      style="background-color: #fff"
      v-if="productList.length === 0 && where.page > 1"
    >
      <div class="noPictrue">
        <img src="@assets/img/noSearch.png" class="image" />
      </div>
    </div>
    <!-- <Recommend v-if="productList.length === 0 && where.page > 1"></Recommend> -->
  </div>
</template>
<script>
// import Recommend from "@components/Recommend";
import debounce from "lodash.debounce";
import Loading from "@components/Loading";
import PromotionGood from "@components/PromotionGood";
import { DropdownMenu, DropdownItem, Cascader, NavBar } from "vant";
import { getCity, getUserInfo } from "@api/user";
import { getCategory, getCoachList } from "@api/store";
import { getDict } from "@api/admin";
import { getArticleDetails } from "@api/public";
import { mapGetters } from "vuex";

export default {
  name: "GoodsList",
  components: {
    // Recommend,
    Loading,
    PromotionGood,
    DropdownMenu,
    DropdownItem,
    Cascader,
    NavBar,
  },
  props: {
    srachState: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    const { s = "", id = 0, pid = -1, title = "" } = this.$route.query;

    return {
      hostProduct: [],
      productList: [],
      Switch: true,
      keyword: "",
      where: {
        page: 1,
        limit: 8,
        keyword: s,
        sid: id, //二级分类id
        pid: pid, //一级分类id
        news: 0,
        priceOrder: "",
        salesOrder: "",
      },
      title: title && id ? title : "",
      loadTitle: "",
      loading: false,
      loadend: false,
      stock: 0,
      nows: false,
      address: 0,
      addressOption: [],
      price: 0,
      priceOption: [],
      type: 0,
      typeOption: [],
      sort: "",
      sortOption: [
        { text: "不限", value: "" },
        { text: "评价最多", value: "commentNumOrder" },
        { text: "约见最多", value: "salesOrder" },
        { text: "价格最低", value: "priceOrder" },
      ],
      addressText: "地区",
      category: [],
      provinceCode: "",
      cityCode: "",
      cateId: "",
      categoryShow: false,
      inputDisabled: true,
      articleImg: {
        1: "",
        2: "",
      },
    };
  },
  computed: {
    refDisable() {
      return this.categoryShow && !this.keyword;
    },
    ...mapGetters(["isLogin"]),
  },
  watch: {
    title() {
      this.updateTitle();
    },
    refDisable(val) {
      this.$emit("popChange", val);
    },
    // $route(to) {
    //   if (to.name !== "GoodsList") return;
    //   const { s = "", id = 0, pid = -1, title = "" } = to.query;
    //   if (
    //     s !== this.where.keyword ||
    //     id !== this.where.sid ||
    //     pid !== this.where.pid
    //   ) {
    //     this.where.keyword = s;
    //     this.loadend = false;
    //     this.loading = false;
    //     this.where.page = 1;
    //     this.where.sid = id;
    //     this.where.pid = pid;
    //     this.title = title && id ? title : "";
    //     this.nows = false;
    //     this.$set(this, "productList", []);
    //     this.price = 0;
    //     this.stock = 0;
    //     this.get_product_list();
    //   }
    // },
  },
  created() {
    this.$store.state.app.token && this.User();
    !this.srachState && this.getNewImg();
  },
  mounted: function () {
    //this.getCityList();
    this.loadCategoryData();
    this.getDict("meet_type", (res) => {
      this.typeOption = [
        { text: "不限", value: "" },
        ...res.data.map((item) => ({ text: item.label, value: item.value })),
      ];
    });
    this.getDict("price_range", (res) => {
      this.priceOption = [
        { text: "不限", value: "" },
        ...res.data.map((item) => ({
          text: "￥" + item.label,
          value: item.value,
        })),
      ];
    });
    this.updateTitle();
    this.get_product_list();
    this.srachState &&
      this.$scroll(this.$refs.container, () => {
        console.log("滚动到底部");
        !this.loading && this.get_product_list();
      });
    // console.log("this.$refs.container", this.$refs.container)
    document.addEventListener(
      "touchstart",
      (event) => {
        var target = event.target;

        // 判断点击的区域是否是选择框或者选项列表
        console.log(target.className);
        if (target.className.indexOf("category-toach") != -1) {
          return; // 如果是选择框或者选项列表，不执行隐藏操作
        }
        // 否则，隐藏选项列表

        let timer = setTimeout(() => {
          this.categoryShow = false;
          clearTimeout(timer);
        });
      },
      false
    );
  },
  methods: {
    getNewImg() {
      getArticleDetails(1584).then((res) => {
        this.articleImg[1] = res.data.imageInput;
      });
      getArticleDetails(1585).then((res) => {
        this.articleImg[2] = res.data.imageInput;
      });
    },
    User: function () {
      let that = this;
      getUserInfo().then((res) => {
        this.$store.state.app.isFirst = res.data.isFirst;
      });
    },
    getDict: function (name, cal) {
      getDict({ name }).then((res) => {
        cal(res);
      });
    },
    loadCategoryData: function () {
      getCategory().then((res) => {
        this.category = res.data;
      });
    },
    updateTitle() {
      document.title = this.title || this.$route.meta.title;
    },
    get_product_list: debounce(function () {
      var that = this;
      if (that.loading) return;
      if (that.loadend) return;
      that.loading = true;
      getCoachList({
        ...(this.sort == "priceOrder" && { priceOrder: 0 }),
        ...(this.sort == "salesOrder" && { salesOrder: 1 }),
        ...(this.sort == "commentNumOrder" && { commentNumOrder: 1 }),
        ...(this.type && { meetType: this.type }),
        ...(this.provinceCode && { provinceCode: this.provinceCode }),
        ...(this.cityCode && { cityCode: this.cityCode }),
        ...(this.cateId && { cateId: this.cateId }),
        ...(this.price && { price: this.price }),
        name: this.keyword,
        page: this.where.page,
      }).then((res) => {
        that.loading = false;
        that.productList.push.apply(that.productList, res.data);
        that.loadend = res.data.length < that.where.limit; //判断所有数据是否加载完成；
        that.where.page = that.where.page + 1;
      });
    }, 300),
    submitForm: function () {
      this.$set(this, "productList", []);
      this.where.page = 1;
      this.loadend = false;
      this.loading = false;
      !this.keyword && (this.cateId = "");
      this.get_product_list();
    },
    addressFinish: function (e) {
      this.addressText = e.selectedOptions[e.selectedOptions.length - 1].n;
      this.provinceCode = e.selectedOptions[0].v;
      this.cityCode = e.selectedOptions[1] ? e.selectedOptions[1].v : "";
      this.$refs.addressItem.toggle();
      this.submitForm();
    },
    switchTap: function () {
      let that = this;
      that.Switch = !that.Switch;
    },
    getCityList: function () {
      let that = this;
      getCity()
        .then((res) => {
          this.addressOption = res.data.map((item) => {
            return {
              n: item.n,
              v: item.v,
              c: item.c.map((ele) => ({ n: ele.n, v: ele.v })),
            };
          });
        })
        .catch((err) => {
          that.$dialog.error(err.msg);
        });
    },
    categorySelect: function (item) {
      this.cateId = item.id;
      this.keyword = item.cateName;
      this.submitForm();
    },
    inputBlur: function () {
      let timer = setTimeout(() => {
        console.log("inputBlur");
        this.categoryShow = false;
        clearTimeout(timer);
      });
      if (!this.keyword) {
        this.inputDisabled = true;
      }
    },
    inputFocus: function () {
      console.log("inputFocus");
      this.categoryShow = true;
    },
    inputClick() {
      console.log("inputClick");
      if (this.inputDisabled) {
        this.categoryShow = true;
        this.inputDisabled = false;
      }
    },
    inputClear: function () {
      let timer = setTimeout(() => {
        this.keyword = "";
        clearTimeout(timer);
      });
    },
    addressOpen: function () {
      this.$emit("popChange", true);
    },
    addressClose: function () {
      this.$emit("popChange", false);
    },
  },
};
</script>
<style scoped lang="scss">
.noCommodity {
  border-top: 3px solid #f5f5f5;
  padding-bottom: 1px;
}
.consultant {
  background: #ffffff;
  /** border-bottom: 0.19rem solid #f5f5f5;*/
  padding: 0.19rem 0.6rem;
}

.nav {
  border-top: 0.19rem solid #f5f5f5;
}

.advert-box {
  padding-top: 0.15rem;
  padding-bottom: 0.2rem;
  img {
    width: 100%;
  }
}
.consultant .consultant-item {
  font-size: 0.23rem;
}
.consultant .consultant-img {
  width: 0.6rem;
  height: 0.6rem;
  margin-right: 0.19rem;
  vertical-align: middle;
}
.fixd {
  position: fixed;
  z-index: 9;
  top: 46px;
  left: 0;
  right: 0;
  background: #ffffff;
}
.search-category {
  position: absolute;
  z-index: 999;
  left: 0;
  right: 0;
  top: 0.8rem;
  background-color: #ffffff;
  height: 6rem;
  overflow-y: scroll;
}
.search-category .search-category-item {
  padding: 0.19rem 0.3rem;
}

.category-toach {
  -webkit-user-select: none; /* readonly 在苹果浏览器上不起作用*/
}
</style>
